import { render, staticRenderFns } from "./MasterHeader.vue?vue&type=template&id=88642a1c&"
import script from "./MasterHeader.vue?vue&type=script&lang=js&"
export * from "./MasterHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports